import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=6529972d"
import script from "./practice.vue?vue&type=script&lang=js"
export * from "./practice.vue?vue&type=script&lang=js"
import style0 from "./practice.vue?vue&type=style&index=0&id=6529972d&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports